import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { SectionFeaturedFigures } from "services/cms/models/sectionFeaturedFigures";

interface ResolvedFigure {
    figure: string;
    label: string;
}

export interface ResolvedFeaturedFigures {
    codename: string;
    figures: [ResolvedFigure, ResolvedFigure, ResolvedFigure];
    type: ContentTypeCodenames.SectionFeaturedFigures;
}

const featuredFiguresResolver = (data: SectionFeaturedFigures): ResolvedFeaturedFigures => {
    return {
        codename: data.system.codename,
        figures: [
            {
                figure: data.elements.figure1.value,
                label: data.elements.label1.value,
            },
            {
                figure: data.elements.figure2.value,
                label: data.elements.label2.value,
            },
            {
                figure: data.elements.figure3.value,
                label: data.elements.label3.value,
            },
        ],
        type: ContentTypeCodenames.SectionFeaturedFigures,
    };
};

export default featuredFiguresResolver;
